import { AfterViewInit, Component, OnInit, signal } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { TIMESHEET_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/timesheet';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { TimesheetStoreService } from '../../../../../state/modules/timesheet/timesheet-store.service';
import { ShiftStatus, TaskGroupListActionControls, TaskGroupStatus } from './task-group-list-action.constant';

@Component({
  standalone: false,
  selector: 'kt-task-group-list-action',
  templateUrl: './task-group-list-action.component.html',
  styleUrls: ['./task-group-list-action.component.scss'],
})
export class TaskGroupListActionComponent implements OnInit, AfterViewInit {
  task = null;
  editTaskInfo = null;
  viewMode = false;
  buttonConfig = BUTTON_CONFIG;
  shiftTimesheetInfo = null;
  timesheet = null;
  isUncsheduled = null;
  taskGroupListDetail = null;
  location = { latitude: CommonUtil.Latitude, logitude: CommonUtil.Longitude };
  taskGroupListActionControls = TaskGroupListActionControls;
  extraTaskFormGroup = new UntypedFormArray([]);
  commentFormGroup = new UntypedFormGroup({});
  saveData = true;
  editMode = false;
  loading = signal(false);
  activeTaskGroupChild = null;
  user_id = 0;
  currentStatus;
  shiftStatusEnum = ShiftStatus;

  constructor(public activeModal: NgbActiveModal, private timeSheetStoreService: TimesheetStoreService) { }

  ngOnInit() {
    if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {
      // navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      // if (result.state === 'granted') {
      navigator.geolocation.getCurrentPosition((position) => {
        this.location.latitude = position.coords.latitude;
        this.location.logitude = position.coords.longitude;
      });
      // }
      // });
    }

    if (this.editMode) {
      this.editTaskInfo = this.task;
      this.task.newTask.forEach(newTaskInfo => this.extraTaskFormGroup.push(new UntypedFormGroup({ saved: new UntypedFormControl() })));
      this.task = this.task.task;

    }
    if (this.task && this.task.task_group_child) {
      this.task.task_group_child.forEach(taskGroupChild => {
        if (taskGroupChild.actual_task_group_child && taskGroupChild.actual_task_group_child.timesheet_task_group_child_multiple_count && taskGroupChild.actual_task_group_child.timesheet_task_group_child_status === TaskGroupStatus.Done && !taskGroupChild.task_group_child_multiple) {
          taskGroupChild.selected = true;
        }
      });
    }
    if (!this.task.task_group_child) {
      this.task.task_group_child = [];
    }
    if (this.task.timesheet_task_group_child) {
      this.task.timesheet_task_group_child.forEach(newAddedTaskGroup => {
        newAddedTaskGroup.selected = newAddedTaskGroup.timesheet_task_group_child_multiple_count ? true : false;
        newAddedTaskGroup.custom = newAddedTaskGroup.timesheet_task_group_child_is_custom;
        newAddedTaskGroup.task_group_child_task = newAddedTaskGroup.timesheet_task_group_child_fk_task_group_child_name;
        this.task.task_group_child.push(newAddedTaskGroup);
      });
    }
  }

  ngAfterViewInit() {
    if (this.editMode) {
      this.commentFormGroup.reset({ comment: this.editTaskInfo.comment });
      this.extraTaskFormGroup.reset(this.editTaskInfo.newTask);
    }
  }

  taskgroupFilled(data) {
    this.loading.set(false);
    if (data.success) {
      const savedTask = data.response.data.Timesheet;
      if (savedTask && savedTask.timesheet_task_group_child[0] && savedTask.timesheet_task_group_child[0].timesheet_task_group_child_is_custom && !this.activeTaskGroupChild) {
        const newCustomTask = {
          selected: true,
          custom: true,
          task_group_child_task: savedTask.timesheet_task_group_child[0].timesheet_task_group_child_fk_task_group_child_name,
        };
        this.task.task_group_child.push(newCustomTask);
        this.extraTaskFormGroup.clear();
      }
      this.task.timesheet_task_group_id = savedTask.timesheet_task_group_id;
      if (this.activeTaskGroupChild && !this.activeTaskGroupChild.timesheet_task_group_child_id) {
        this.activeTaskGroupChild.timesheet_task_group_child_id = savedTask.timesheet_task_group_child[0].timesheet_task_group_child_id;
      }
      // this.activeModal.close({ reload: true });
      if (this.activeTaskGroupChild && this.activeTaskGroupChild.actual_task_group_child) {
        if (this.activeTaskGroupChild.task_group_child_multiple) {
          this.activeTaskGroupChild.selected = false;
          this.activeTaskGroupChild.actual_task_group_child.timesheet_task_group_child_multiple_count = this.activeTaskGroupChild.actual_task_group_child.timesheet_task_group_child_multiple_count + 1;
        }
      } else if (this.activeTaskGroupChild && this.activeTaskGroupChild.task_group_child_multiple) {
        this.activeTaskGroupChild.selected = false;
        this.activeTaskGroupChild.actual_task_group_child = {
          timesheet_task_group_child_multiple_count: 1,
        };
      }
    }
    this.activeTaskGroupChild = null;
  }

  removeTaskGroup(index) {
    this.extraTaskFormGroup.removeAt(index);
  }

  addClickHandler() {
    this.extraTaskFormGroup.push(new UntypedFormGroup({ saved: new UntypedFormControl(false) }));
  }

  taskSelectChangeHandler(selected, task) {
    if (this.saveData) {
      this.saveButtonClickHandler(selected, task);
      this.activeTaskGroupChild = task;
    }

    // const unselectedExist = this.task.task_group_child.find(task => !task.selected);
    // if (unselectedExist) {
    //   setTimeout(() => {
    //     this.commentFormGroup.get('comment').setValidators([Validators.required]);
    //     this.commentFormGroup.get('comment').updateValueAndValidity();
    //     this.commentFormGroup.markAllAsTouched();
    //   }, 10);

    // } else {
    //   setTimeout(() => {
    //     this.commentFormGroup.get('comment').clearValidators();
    //     this.commentFormGroup.get('comment').updateValueAndValidity();
    //   }, 10);
    // }
  }

  internalSaveClick(extraTask) {
    if (this.extraTaskFormGroup.invalid) {
      return this.extraTaskFormGroup.markAllAsTouched();
    }
    extraTask.get('saved').setValue(true);
  };

  saveButtonClickHandler(selected, changedTaskChild) {
    if (this.extraTaskFormGroup.invalid) {
      return this.extraTaskFormGroup.markAllAsTouched();
    }

    // if (!this.commentFormGroup.valid) {
    //   return this.commentFormGroup.markAllAsTouched();
    // }


    const comment = '';
    const taskgroup = this.task.task_group || this.task;
    const changeTaskChild = changedTaskChild ? [changedTaskChild] : [];

    const paylodForSelectedTasks = changeTaskChild.map(task => {
      return {
        timesheet_task_group_child_id: changedTaskChild ? (changedTaskChild.actual_task_group_child ? changedTaskChild.actual_task_group_child.timesheet_task_group_child_id : 0) || changedTaskChild.timesheet_task_group_child_id : 0,
        timesheet_task_group_child_fk_task_group_id: taskgroup.task_group_id,
        timesheet_task_group_child_fk_task_group_child_id: task.task_group_child_id,
        timesheet_task_group_child_fk_task_group_child_name: task.task_group_child_task,
        timesheet_task_group_child_status: task.selected ? TaskGroupStatus.Done : TaskGroupStatus.NotDone,
      };
    });

    paylodForSelectedTasks.push(...this.extraTaskFormGroup.value.map(task => {
      return {
        timesheet_task_group_child_fk_task_group_id: taskgroup.task_group_id,
        timesheet_task_group_child_fk_task_group_child_id: 0,
        timesheet_task_group_child_fk_task_group_child_name: task.task_group,
        timesheet_task_group_child_status: TaskGroupStatus.Done,
      };
    }));

    if (!this.saveData) {
      const savedSelectedTasks = this.task.task_group_child.map((child) => {
        return {
          timesheet_task_group_child_id: child ? (child.actual_task_group_child ? child.actual_task_group_child.timesheet_task_group_child_id : 0) || child.timesheet_task_group_child_id : 0,
          timesheet_task_group_child_fk_task_group_id: taskgroup.task_group_id,
          timesheet_task_group_child_fk_task_group_child_id: child.task_group_child_id,
          timesheet_task_group_child_fk_task_group_child_name: child.task_group_child_task,
          timesheet_task_group_child_status: child.selected ? TaskGroupStatus.Done : TaskGroupStatus.NotDone,
        };
      });
      const allTaskDone = this.task.task_group_child.find(task => !task.selected) ? false : true;

      paylodForSelectedTasks.push(...savedSelectedTasks);
      const doneTasks = {
        timesheet_task_group_fk_task_group_id: taskgroup.task_group_id,
        timesheet_task_group_fk_task_group_name: taskgroup.task_group_name,
        timesheet_task_group_comments: comment,
        timesheet_task_group_childs: paylodForSelectedTasks,
      };
      this.activeModal.close({ tasks: doneTasks, allTaskDone, taskForEditMode: { comment, task: this.task, newTask: this.extraTaskFormGroup.value } });

      return;
    }

    const payload = {
      action_type: selected ? TaskGroupStatus.Add : TaskGroupStatus.Delete,
      client_id: this.shiftTimesheetInfo.client.client_id,
      location_id: this.shiftTimesheetInfo.location.location_id,
      area_id: this.shiftTimesheetInfo.area.area_id,
      timezone_id: 1,
      user_id: this.user_id ? this.user_id : 0,
      is_unscheduled: this.isUncsheduled,
      timesheet_id: this.timesheet.timesheet_id,
      task_group_id: taskgroup.task_group_id,
      shift_task_group_id: this.taskGroupListDetail ? this.taskGroupListDetail.shift_task_group_id : 0,
      location_task_group_id: this.taskGroupListDetail ? this.taskGroupListDetail.location_task_group_id : 0,
      type: this.taskGroupListDetail && this.taskGroupListDetail.location_task_group_id ? TimesheetType.LOCATION : TimesheetType.SHIFT,
      timesheet_log: {
        timesheet_log_name: taskgroup.task_group_name,
        timesheet_log_config: {},
        timesheet_log_is_paid: false,
      },
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: '',
        timesheet_transaction_scan_type: '',
        timesheet_transaction_scan_image_url: '',
        timesheet_transaction_notes: '',
        timesheet_transaction_latitude: this.location.latitude.toString(),
        timesheet_transaction_longitude: this.location.logitude.toString(),
        timesheet_transaction_accuracy: 0,
      },
      timesheet_task_group: {
        timesheet_task_group_child_id: changedTaskChild ? (changedTaskChild.actual_task_group_child ? changedTaskChild.actual_task_group_child.timesheet_task_group_child_id : 0) || changedTaskChild.timesheet_task_group_child_id : 0,
        timesheet_task_group_id: this.task.timesheet_task_group_id || (this.task.timesheet_task_group ? this.task.timesheet_task_group.timesheet_task_group_id : 0),
        timesheet_task_group_fk_task_group_id: taskgroup.task_group_id,
        timesheet_task_group_fk_task_group_name: taskgroup.task_group_name,
        timesheet_task_group_comments: comment,
        timesheet_task_group_childs: paylodForSelectedTasks,
      },
    };
    this.dispatchTaskGroup(payload);
  }

  dispatchTaskGroup(data) {
    this.loading.set(true);
    this.timeSheetStoreService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.TASK_GROUP,
      method: API_METHOD_CONSTANTS.INSERT,
      data,
      callback: this.taskgroupFilled.bind(this),
    });
  }
}
